// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import de from 'vee-validate/dist/locale/de'
import VeeValidate, { Validator } from 'vee-validate'
import {Tabs, Tab} from 'vue-tabs-component'
import axios from 'axios/index'
import toast from './helpers/toast'

var $ = require('jquery')
Vue.config.productionTip = false

// VEE-Validation + Import Basic Locale for de
Vue.use(VeeValidate)
Validator.localize('de', de)
Validator.localize('en')

Vue.component('tabs', Tabs)
Vue.component('tab', Tab)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  mounted () {
    this.$store.dispatch('getTranslation')
    if ((typeof window.sessionStorage.jwt !== 'undefined') && (window.sessionStorage.expires - Math.floor(Date.now() / 1000)) > 0) {
      this.$store.dispatch('computes/getComputes')
      this.$store.dispatch('flavors/getFlavors')
      this.$store.dispatch('keypairs/getKeypairs')
      this.$store.dispatch('images/getImages')
      this.$store.dispatch('user/getUser')
      this.$store.dispatch('floating/getFloating')
      this.$store.dispatch('snapshots/getSnapshot')
    }

    axios.interceptors.response.use(
      response => response,
      this.errorResponseHandler
    )
  },
  data: function () {
    return {
      interval: null
    }
  },
  methods: {
    refresh: function () {
      this.interval = setInterval(function () {
        if (router.history.current.path.indexOf('app') > 0 && ((typeof window.sessionStorage.jwt === 'undefined') || (window.sessionStorage.expires - Math.floor(Date.now() / 1000)) <= 0)) {
          router.push({name: 'Login'})
          window.sessionStorage.clear()
        }
      }, 1000)
    },
    errorResponseHandler: function (error) {
      // check for errorHandle config
      if (error.config.hasOwnProperty('errorHandle') && error.config.errorHandle === false) {
        return Promise.reject(error)
      }
      // handle error
      if (error.response) {
        for (let i = 0; i < error.response.data.count; i++) {
          let message = this.$store.state.locale.error['e' + error.response.data.errors[i].code]
          if (message === undefined) {
            message = this.$store.state.locale.error.e500
          }
          toast.error(message + ' - Code: ' + error.response.data.errors[i].code)
        }
      }
      return new Error(error)
    }
  },
  created () {
    this.refresh()
  },
  beforeDestroy: function () {
    clearInterval(this.interval)
  }
})

/* Show more button */
$('.size').hide()
$('.size').slice(0, 3).show()
$('#showMore').click(function () {
  $('.size').show()
  $('#showMore').hide()
})



// WEBPACK FOOTER //
// ./src/main.js